"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var propTypes = {
    capabilities: PropTypes.arrayOf(PropTypes.element)
};
function createElementTree(elements, children) {
    if (elements.length === 0) {
        return children;
    }
    var instance = elements.pop();
    return React.cloneElement(instance, {
        children: createElementTree(elements, children)
    });
}
/**
 * The `CapabilityProvider` is a technical component that will wrap React components around its children.
 */
var CapabilityProvider = /** @class */ (function (_super) {
    __extends(CapabilityProvider, _super);
    function CapabilityProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CapabilityProvider.prototype.render = function (argChildren) {
        var children = argChildren || this.props.children;
        var capabilities = this.props.capabilities;
        var reversedCapabilities = __spreadArrays(capabilities).reverse();
        return createElementTree(reversedCapabilities, children);
    };
    CapabilityProvider.propTypes = propTypes;
    CapabilityProvider.defaultProps = {
        capabilities: []
    };
    return CapabilityProvider;
}(react_1.Component));
exports.CapabilityProvider = CapabilityProvider;
exports.default = CapabilityProvider;
//# sourceMappingURL=CapabilityProvider.js.map